// AI Generated Test
import { Component, Input } from '@angular/core';

@Component({
    selector: 'notification-text',
    standalone: false,
    template: `
        <div class="notification d-flex pt-3 pb-4 pl-7" tabindex="0">
            <div class="mt-2" *ngIf="faIcon">
                <span [ngClass]="[classColor, faIcon]"></span>
            </div>
            <div [ngClass]="{ 'pl-4': faIcon}">
                <ul class="list-unstyled">
                    <li class="text-secondary-4">{{ title }}</li>
                    <li class="font-size-1-5 font-weight-300">
                        <span class="vtop text-secondary-4">{{ text }}</span>
                        <span class="font-size-0-6 vtop mt-1 text-secondary-4" [ngClass]="miniText">
                            {{ miniText }}
                        </span>
                    </li>
                    <li class="text-secondary-4">
                        <ng-content></ng-content>
                    </li>
                </ul>
            </div>
        </div>
    `,
})
export class NotificationTextComponent {
    @Input() faIcon?: string;
    @Input() title!: string;
    @Input() text!: string;
    @Input() miniText!: string;
    @Input() classColor?: string;
}
